// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { IdvConnectionTemplate } from '../../../api/types';
import type { useTranslation } from 'react-i18next';
import { TRANSLATION_ROOT } from './IdvConnections.types';

export const getBadgeColor = (templateType: IdvConnectionTemplate) => {
  switch (templateType) {
    case IdvConnectionTemplate.EPIC_CARE_LINK: return 'cyan';
    case IdvConnectionTemplate.SERVICE_NOW: return 'purple';
    case IdvConnectionTemplate.CUSTOM: return 'magenta';
    default: return 'default';
  }
};

export const getBadgeLabel = (
  templateType: IdvConnectionTemplate,
  t: ReturnType<typeof useTranslation>['t'],
) => {
  switch (templateType) {
    case IdvConnectionTemplate.EPIC_CARE_LINK:
      return t(`${TRANSLATION_ROOT}.template-epic-care-link-badge`);
    case IdvConnectionTemplate.SERVICE_NOW:
      return t(`${TRANSLATION_ROOT}.template-service-now-badge`);
    case IdvConnectionTemplate.CUSTOM:
      return t(`${TRANSLATION_ROOT}.template-custom-badge`);
    // Mirrors getBadgeColor's neutral 'default': show the raw template type rather than
    // mislabelling an unknown/future template as a Custom IDV connection.
    default:
      return templateType;
  }
};
